import React from 'react';

export const DownArrowRounded = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.3896 8.41987C19.6825 8.127 20.1572 8.12705 20.4501 8.41987C20.743 8.71276 20.743 9.18752 20.4501 9.48041L13.9306 16.0009C12.8677 17.0637 11.1321 17.0638 10.0693 16.0009L3.54975 9.48041C3.25685 9.18752 3.25685 8.71276 3.54975 8.41987C3.84264 8.12697 4.3174 8.12697 4.61029 8.41987L11.1308 14.9394C11.6079 15.4165 12.393 15.4165 12.8701 14.9394L19.3896 8.41987Z"
      fill="#64748B"
    />
  </svg>
);
